// Utils
import { createAction } from 'redux-actions'

export const apiRequest = createAction('API_REQUEST')
